
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputMouse3 as ObiInputMouse3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-mouse-3.js';
 
 
 

 
 export const ObiInputMouse3 = createComponent({
   react: React,
   tagName: 'obi-input-mouse-3',
   elementClass: ObiInputMouse3Element,
   events: {
     
   }
  });
 
 